/**
 * European Union member states and sample cities for location selector.
 * Can be expanded with full city lists per member state.
 */

export const STATES = [
  'Austria',
  'Belgium',
  'Bulgaria',
  'Croatia',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Germany',
  'Greece',
  'Hungary',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Poland',
  'Portugal',
  'Romania',
  'Slovakia',
  'Slovenia',
  'Spain',
  'Sweden',
  'Other',
];

export const CITIES_BY_STATE = {
  Austria: [
    'Vienna', 'Graz', 'Linz', 'Salzburg', 'Innsbruck', 'Klagenfurt',
    'Villach', 'Wels', 'Sankt Pölten', 'Dornbirn', 'Steyr', 'Wiener Neustadt',
    'Feldkirch', 'Bregenz', 'Leonding', 'Klosterneuburg', 'Baden',
    'Wolfsberg', 'Leoben', 'Krems', 'Traun', 'Amstetten', 'Lustenau',
    'Kapfenberg', 'Mödling', 'Hallein', 'Kufstein', 'Traiskirchen',
    'Schwechat', 'Braunau am Inn', 'Spittal an der Draun', 'Schwarzach',
    'Eisenstadt', 'Other',
  ],
  Belgium: [
    'Brussels', 'Antwerp', 'Ghent', 'Charleroi', 'Liège', 'Bruges',
    'Namur', 'Leuven', 'Mons', 'Aalst', 'Mechelen', 'La Louvière',
    'Kortrijk', 'Hasselt', 'Ostend', 'Tournai', 'Genk', 'Seraing',
    'Roeselare', 'Verviers', 'Mouscron', 'Beveren', 'Beringen',
    'Dendermonde', 'Heist-op-den-Berg', 'Sint-Niklaas', 'Lokeren',
    'Turnhout', 'Dilbeek', 'Heusden-Zolder', 'Lier', 'Ypres', 'Other',
  ],
  Bulgaria: [
    'Sofia', 'Plovdiv', 'Varna', 'Burgas', 'Ruse', 'Stara Zagora',
    'Pleven', 'Sliven', 'Dobrich', 'Shumen', 'Pernik', 'Haskovo',
    'Yambol', 'Pazardzhik', 'Blagoevgrad', 'Veliko Tarnovo', 'Vratsa',
    'Gabrovo', 'Vidin', 'Kardzhali', 'Kyustendil', 'Smolyan', 'Targovishte',
    'Lovech', 'Razgrad', 'Silistra', 'Montana', 'Asenovgrad', 'Aytos',
    'Botevgrad', 'Chirpan', 'Devnya', 'Dimitrovgrad', 'Dupnitsa',
    'Gorna Oryahovitsa', 'Kazanlak', 'Karlovo', 'Kozloduy', 'Lom',
    'Nova Zagora', 'Panagyurishte', 'Peshtera', 'Petrich', 'Popovo',
    'Rakovski', 'Samokov', 'Sandanski', 'Simitli', 'Sopot', 'Sredets',
    'Svilengrad', 'Troyan', 'Velingrad', 'Pavlikeni', 'Sevlievo',
    'Rakovski', 'Razlog', 'Teteven', 'Trojan', 'Harmanli', 'Other',
  ],
  Croatia: [
    'Zagreb', 'Split', 'Rijeka', 'Osijek', 'Zadar', 'Slavonski Brod',
    'Pula', 'Karlovac', 'Sisak', 'Varaždin', 'Šibenik', 'Dubrovnik',
    'Bjelovar', 'Kaštela', 'Vinkovci', 'Velika Gorica', 'Vukovar',
    'Đakovo', 'Poreč', 'Požega', 'Virovitica', 'Gospić', 'Koprivnica',
    'Crikvenica', 'Čakovec', 'Orahovica', 'Buzet', 'Daruvar', 'Samobor',
    'Other',
  ],
  Cyprus: [
    'Nicosia', 'Limassol', 'Larnaca', 'Paphos', 'Famagusta', 'Kyrenia',
    'Lefkara', 'Paralimni', 'Latsia', 'Strovolos', 'Engomi', 'Agios Athanasios',
    'Morphou', 'Yermasogeia', 'Mesa Geitonia', 'Aradippou', 'Other',
  ],
  'Czech Republic': [
    'Prague', 'Brno', 'Ostrava', 'Plzeň', 'Liberec', 'Olomouc',
    'Ústí nad Labem', 'Hradec Králové', 'České Budějovice', 'Pardubice',
    'Havířov', 'Zlín', 'Kladno', 'Most', 'Karviná', 'Opava', 'Frýdek-Místek',
    'Karlovy Vary', 'Jihlava', 'Teplice', 'Děčín', 'Chomutov', 'Přerov',
    'Jablonec nad Nisou', 'Mladá Boleslav', 'Prostějov', 'Třebíč',
    'Třinec', 'Tábor', 'Znojmo', 'Bruntál', 'Cheb', 'Other',
  ],
  Denmark: [
    'Copenhagen', 'Aarhus', 'Odense', 'Aalborg', 'Esbjerg', 'Randers',
    'Kolding', 'Horsens', 'Vejle', 'Roskilde', 'Herning', 'Hørsholm',
    'Helsingør', 'Silkeborg', 'Næstved', 'Greve', 'Fredericia', 'Viborg',
    'Køge', 'Holstebro', 'Taastrup', 'Slagelse', 'Hillerød', 'Sønderborg',
    'Frederiksberg', 'Other',
  ],
  Estonia: [
    'Tallinn', 'Tartu', 'Narva', 'Pärnu', 'Kohtla-Järve', 'Viljandi',
    'Rakvere', 'Maardu', 'Sillamäe', 'Kuressaare', 'Võru', 'Valga',
    'Haapsalu', 'Jõhvi', 'Paide', 'Keila', 'Põlva', 'Jõgeva', 'Rapla',
    'Other',
  ],
  Finland: [
    'Helsinki', 'Espoo', 'Tampere', 'Vantaa', 'Oulu', 'Turku',
    'Jyväskylä', 'Lahti', 'Kuopio', 'Pori', 'Joensuu', 'Lappeenranta',
    'Hämeenlinna', 'Vaasa', 'Seinäjoki', 'Rovaniemi', 'Mikkeli', 'Kotka',
    'Salo', 'Porvoo', 'Kouvola', 'Hyvinkää', 'Lohja', 'Järvenpää',
    'Kokkola', 'Rauma', 'Tuusula', 'Kirkkonummi', 'Kajaani', 'Nokia',
    'Other',
  ],
  France: [
    'Paris', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes',
    'Strasbourg', 'Montpellier', 'Bordeaux', 'Lille', 'Rennes', 'Reims',
    'Le Havre', 'Saint-Étienne', 'Toulon', 'Grenoble', 'Dijon', 'Angers',
    'Nîmes', 'Villeurbanne', 'Le Mans', 'Aix-en-Provence', 'Brest',
    'Tours', 'Amiens', 'Limoges', 'Annecy', 'Perpignan', 'Boulogne-Billancourt',
    'Metz', 'Besançon', 'Orléans', 'Saint-Denis', 'Argenteuil', 'Rouen',
    'Mulhouse', 'Caen', 'Saint-Paul', 'Nancy', 'Tourcoing', 'Roubaix',
    'Avignon', 'Vitry-sur-Seine', 'Créteil', 'Dunkerque', 'Poitiers',
    'Asnières-sur-Seine', 'Courbevoie', 'Versailles', 'Colombes',
    'Aubervilliers', 'Aulnay-sous-Bois', 'Other',
  ],
  Germany: [
    'Berlin', 'Hamburg', 'Munich', 'Cologne', 'Frankfurt', 'Stuttgart',
    'Düsseldorf', 'Leipzig', 'Dortmund', 'Essen', 'Bremen', 'Dresden',
    'Hanover', 'Nuremberg', 'Duisburg', 'Bochum', 'Wuppertal', 'Bielefeld',
    'Bonn', 'Münster', 'Karlsruhe', 'Mannheim', 'Augsburg', 'Wiesbaden',
    'Gelsenkirchen', 'Mönchengladbach', 'Braunschweig', 'Chemnitz',
    'Kiel', 'Aachen', 'Halle (Saale)', 'Magdeburg', 'Freiburg', 'Krefeld',
    'Lübeck', 'Mainz', 'Erfurt', 'Oberhausen', 'Heidelberg', 'Rostock',
    'Kassel', 'Hagen', 'Hamm', 'Saarbrücken', 'Mülheim', 'Herne',
    'Ludwigshafen', 'Osnabrück', 'Oldenburg', 'Leverkusen', 'Solingen',
    'Potsdam', 'Neuss', 'Heilbronn', 'Paderborn', 'Regensburg', 'Würzburg',
    'Ingolstadt', 'Wolfsburg', 'Göttingen', 'Other',
  ],
  Greece: [
    'Athens', 'Thessaloniki', 'Patras', 'Piraeus', 'Larissa', 'Heraklion',
    'Peristeri', 'Kallithea', 'Acharnes', 'Kalamaria', 'Nikaia', 'Glyfada',
    'Volos', 'Ilio', 'Ilioupoli', 'Keratsini', 'Marousi', 'Evosmos',
    'Korydallos', 'Trikala', 'Vyronas', 'Agios Dimitrios', 'Egaleo',
    'Nea Smyrni', 'Petroupoli', 'Galatsi', 'Khaidari', 'Gianitsa',
    'Chania', 'Ioannina', 'Xanthi', 'Kavala', 'Komotini', 'Serres',
    'Veria', 'Drama', 'Other',
  ],
  Hungary: [
    'Budapest', 'Debrecen', 'Szeged', 'Miskolc', 'Pécs', 'Győr',
    'Nyíregyháza', 'Kecskemét', 'Székesfehérvár', 'Szombathely', 'Szekszárd',
    'Érd', 'Kaposvár', 'Sopron', 'Veszprém', 'Békéscsaba', 'Zalaegerszeg',
    'Eger', 'Nagykanizsa', 'Dunaújváros', 'Hódmezővásárhely', 'Cegléd',
    'Baja', 'Salgótarján', 'Vác', 'Ózd', 'Mosonmagyaróvár', 'Pápa',
    'Gyula', 'Other',
  ],
  Ireland: [
    'Dublin', 'Cork', 'Limerick', 'Galway', 'Waterford', 'Drogheda',
    'Swords', 'Dundalk', 'Bray', 'Navan', 'Ennis', 'Kilkenny', 'Tralee',
    'Carlow', 'Newbridge', 'Portlaoise', 'Naas', 'Athlone', 'Mullingar',
    'Wexford', 'Letterkenny', 'Sligo', 'Clonmel', 'Greystones', 'Malahide',
    'Leixlip', 'Tullamore', 'Killarney', 'Arklow', 'Maynooth', 'Other',
  ],
  Italy: [
    'Rome', 'Milan', 'Naples', 'Turin', 'Palermo', 'Genoa',
    'Bologna', 'Florence', 'Bari', 'Catania', 'Venice', 'Verona',
    'Messina', 'Padua', 'Trieste', 'Brescia', 'Parma', 'Prato',
    'Taranto', 'Modena', 'Reggio Calabria', 'Reggio Emilia', 'Perugia',
    'Livorno', 'Ravenna', 'Cagliari', 'Foggia', 'Rimini', 'Salerno',
    'Ferrara', 'Sassari', 'Latina', 'Giugliano in Campania', 'Monza',
    'Siracusa', 'Pescara', 'Bergamo', 'Forlì', 'Trento', 'Vicenza',
    'Terni', 'Bolzano', 'Novara', 'Piacenza', 'Ancona', 'Andria',
    'Arezzo', 'Udine', 'Cesena', 'Lecce', 'Pesaro', 'Barletta',
    'Alessandria', 'La Spezia', 'Pescara', 'Pisa', 'Catanzaro', 'Lucca',
    'Cremona', 'Other',
  ],
  Latvia: [
    'Riga', 'Daugavpils', 'Liepāja', 'Jelgava', 'Jūrmala', 'Ventspils',
    'Rēzekne', 'Valmiera', 'Jēkabpils', 'Ogre', 'Tukums', 'Cēsis',
    'Salaspils', 'Kuldīga', 'Olaine', 'Saldus', 'Dobele', 'Kārsava',
    'Other',
  ],
  Lithuania: [
    'Vilnius', 'Kaunas', 'Klaipėda', 'Šiauliai', 'Panevėžys', 'Alytus',
    'Marijampolė', 'Mažeikiai', 'Jonava', 'Utena', 'Kėdainiai', 'Telšiai',
    'Tauragė', 'Visaginas', 'Ukmergė', 'Plungė', 'Kretinga', 'Palanga',
    'Druskininkai', 'Other',
  ],
  Luxembourg: [
    'Luxembourg City', 'Esch-sur-Alzette', 'Differdange', 'Dudelange',
    'Ettelbruck', 'Diekirch', 'Wiltz', 'Echternach', 'Remich', 'Grevenmacher',
    'Rumelange', 'Capellen', 'Mamer', 'Strassen', 'Bertrange', 'Hesperange',
    'Other',
  ],
  Malta: [
    'Valletta', 'Birkirkara', 'Mosta', 'Qormi', 'Żabbar', 'Sliema',
    'San Pawl il-Baħar', 'Naxxar', 'Fgura', 'Żejtun', 'Rabat', 'Marsaskala',
    'Birżebbuġa', 'Attard', 'Mellieħa', 'Xagħra', 'Victoria', 'Hamrun',
    'Other',
  ],
  Netherlands: [
    'Amsterdam', 'Rotterdam', 'The Hague', 'Utrecht', 'Eindhoven',
    'Tilburg', 'Groningen', 'Almere', 'Breda', 'Nijmegen', 'Enschede',
    'Apeldoorn', 'Haarlem', 'Arnhem', 'Amersfoort', 'Zaanstad',
    "'s-Hertogenbosch", 'Haarlemmermeer', 'Zwolle', 'Zoetermeer',
    'Leeuwarden', 'Leiden', 'Maastricht', 'Dordrecht', 'Ede', 'Alphen aan den Rijn',
    'Westland', 'Alkmaar', 'Emmen', 'Delft', 'Heerlen', 'Hilversum',
    'Purmerend', 'Spijkenisse', 'Gouda', 'Lelystad', 'Veenendaal',
    'Vlaardingen', 'Capelle aan den IJssel', 'Hoorn', 'Amstelveen',
    'Other',
  ],
  Poland: [
    'Warsaw', 'Kraków', 'Łódź', 'Wrocław', 'Poznań', 'Gdańsk',
    'Szczecin', 'Bydgoszcz', 'Lublin', 'Białystok', 'Katowice',
    'Gdynia', 'Częstochowa', 'Radom', 'Sosnowiec', 'Toruń', 'Kielce',
    'Rzeszów', 'Gliwice', 'Zabrze', 'Olsztyn', 'Bielsko-Biała',
    'Bytom', 'Zielona Góra', 'Ruda Śląska', 'Rybnik', 'Opole',
    'Tychy', 'Gorzów Wielkopolski', 'Płock', 'Elbląg', 'Wałbrzych',
    'Tarnów', 'Włocławek', 'Chorzów', 'Koszalin', 'Świnoujście',
    'Kalisz', 'Legnica', 'Grudziądz', 'Other',
  ],
  Portugal: [
    'Lisbon', 'Porto', 'Amadora', 'Braga', 'Coimbra', 'Funchal',
    'Setúbal', 'Agualva-Cacém', 'Queluz', 'Aveiro', 'Vila Nova de Gaia',
    'Évora', 'Faro', 'Loures', 'Rio Tinto', 'Odivelas', 'Amora', 'Felanicho',
    'Leiria', 'Barreiro', 'Almada', 'Cascais', 'Sintra', 'Guimarães',
    'Viseu', 'Póvoa de Varzim', 'Vila Franca de Xira', 'Maia', 'Matosinhos',
    'Beja', 'Portimão', 'Castelo Branco', 'Other',
  ],
  Romania: [
    'Bucharest', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța', 'Craiova',
    'Brașov', 'Galați', 'Ploiești', 'Oradea', 'Brăila', 'Arad', 'Pitești',
    'Sibiu', 'Bacău', 'Târgu Mureș', 'Baia Mare', 'Buzău', 'Botoșani',
    'Satu Mare', 'Râmnicu Vâlcea', 'Drobeta-Turnu Severin', 'Suceava',
    'Piatra Neamț', 'Târgu Jiu', 'Tulcea', 'Târgoviște', 'Focșani',
    'Bistrița', 'Reșița', 'Sfântu Gheorghe', 'Călărași', 'Alba Iulia',
    'Other',
  ],
  Slovakia: [
    'Bratislava', 'Košice', 'Prešov', 'Žilina', 'Nitra', 'Banská Bystrica',
    'Trnava', 'Trenčín', 'Martin', 'Poprad', 'Prievidza', 'Zvolen',
    'Považská Bystrica', 'Michalovce', 'Spišská Nová Ves', 'Komárno',
    'Levice', 'Humenné', 'Liptovský Mikuláš', 'Bardejov', 'Ružomberok',
    'Piešťany', 'Other',
  ],
  Slovenia: [
    'Ljubljana', 'Maribor', 'Celje', 'Kranj', 'Koper', 'Velenje',
    'Novo Mesto', 'Ptuj', 'Trbovlje', 'Kamnik', 'Jesenice', 'Nova Gorica',
    'Domžale', 'Škofja Loka', 'Murska Sobota', 'Postojna', 'Vipava',
    'Krško', 'Slovenj Gradec', 'Other',
  ],
  Spain: [
    'Madrid', 'Barcelona', 'Valencia', 'Seville', 'Zaragoza', 'Málaga',
    'Murcia', 'Palma', 'Las Palmas', 'Bilbao', 'Alicante', 'Córdoba',
    'Valladolid', 'Vigo', 'Gijón', 'L Hospitalet de Llobregat', 'Vitoria',
    'A Coruña', 'Granada', 'Elche', 'Oviedo', 'Badalona', 'Cartagena',
    'Terrassa', 'Jerez de la Frontera', 'Sabadell', 'Móstoles',
    'Santa Cruz de Tenerife', 'Pamplona', 'Alcalá de Henares',
    'Almería', 'San Sebastián', 'Leganes', 'Santander', 'Burgos',
    'Castellón de la Plana', 'Albacete', 'Alcorcón', 'Getafe', 'Salamanca',
    'Logroño', 'San Cristóbal de La Laguna', 'Badajoz', 'Tarragona',
    'León', 'Cádiz', 'Dos Hermanas', 'Other',
  ],
  Sweden: [
    'Stockholm', 'Gothenburg', 'Malmö', 'Uppsala', 'Västerås', 'Örebro',
    'Linköping', 'Helsingborg', 'Jönköping', 'Norrköping', 'Lund',
    'Umeå', 'Gävle', 'Borås', 'Eskilstuna', 'Södertälje', 'Karlstad',
    'Växjö', 'Halmstad', 'Sundsvall', 'Luleå', 'Trollhättan', 'Östersund',
    'Borlänge', 'Tumba', 'Upplands Väsby', 'Falun', 'Kalmar', 'Kristianstad',
    'Karlskrona', 'Other',
  ],
  Other: ['Other'],
};

export const getCitiesForState = (state) =>
  (state && CITIES_BY_STATE[state]) || [];
